// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TranscribeAudioMutationVariables = Types.Exact<{
  upload: Types.Scalars['Upload']['input'];
}>;


export type TranscribeAudioMutation = { __typename?: 'Mutation', transcribeAudio: string };

export const Operations = {
  Mutation: {
    TranscribeAudio: 'TranscribeAudio' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const TranscribeAudioDocument = gql`
    mutation TranscribeAudio($upload: Upload!) {
  transcribeAudio(upload: $upload)
}
    `;
export type TranscribeAudioMutationFn = Apollo.MutationFunction<TranscribeAudioMutation, TranscribeAudioMutationVariables>;

/**
 * __useTranscribeAudioMutation__
 *
 * To run a mutation, you first call `useTranscribeAudioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTranscribeAudioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transcribeAudioMutation, { data, loading, error }] = useTranscribeAudioMutation({
 *   variables: {
 *      upload: // value for 'upload'
 *   },
 * });
 */
export function useTranscribeAudioMutation(baseOptions?: Apollo.MutationHookOptions<TranscribeAudioMutation, TranscribeAudioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TranscribeAudioMutation, TranscribeAudioMutationVariables>(TranscribeAudioDocument, options);
      }
export type TranscribeAudioMutationHookResult = ReturnType<typeof useTranscribeAudioMutation>;
export type TranscribeAudioMutationResult = Apollo.MutationResult<TranscribeAudioMutation>;
export type TranscribeAudioMutationOptions = Apollo.BaseMutationOptions<TranscribeAudioMutation, TranscribeAudioMutationVariables>;